// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Bank = function Bank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.453.117a.94.94 0 0 0-.906 0L.687 5.004C.263 5.238 0 5.684 0 6.168 0 6.906.594 7.5 1.332 7.5h17.34a1.331 1.331 0 0 0 .644-2.496zM8.918 5.625H3.445L10 2.008l6.555 3.617h-5.473A1.249 1.249 0 0 0 10 3.75a1.249 1.249 0 0 0-1.082 1.875M2.5 8.75V15a.935.935 0 0 0-.937.938c0 .519.417.937.937.937h15.313c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H17.5V8.75h-1.875V15h-2.5V8.75H11.25V15h-2.5V8.75H6.875V15h-2.5V8.75zm-1.25 9.375a.935.935 0 0 0-.937.938c0 .519.417.937.937.937h17.813c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
